module.exports = __webpack_public_path__ + "img/1723614782787-WhatsApp Image 2024-08-14 at 13.45.27 1.jpeg.1e1782c7.webp";